import { z } from 'zod';
import { EntitySuggestionStatusSchema, EntitySuggestionKindSchema, PopulatedEntitySuggestionSchema } from '../../entities/entity-suggestion';
export const ListEntitySuggestionsQuerySchema = z.object({
    status: EntitySuggestionStatusSchema.optional(),
    kind: EntitySuggestionKindSchema.optional(),
    // when set, returns only suggestions visible to this user as approver:
    forApprover: z.literal('me').optional()
});
export const ListEntitySuggestionsResponseSchema = z.object({
    data: z.array(PopulatedEntitySuggestionSchema)
});

//# sourceMappingURL=list-entity-suggestions.contract.js.map